


















import Vue from 'vue';
import * as api from '@/api';

export default Vue.extend({
    computed: {
        compareList(): api.CompareList[] {
            return this.$store.state.compareProductList;
        },
    },
    data() {
        return {};
    },
    methods: {
        remove(product) {
            this.$store.dispatch('deleteProductCompareById', product.productId);
        },
        clear() {
            this.$store.dispatch('deleteAllProductCompare'); // 清空
        },
        compare() {
            if (this.$route.name === 'Compare') {
                this.$store.commit('reloadVs', true);
            } else {
                this.$router.push({
                    path: '/compare/parameter',
                });
            }
        },
    },
});
